import { Box, Grid } from "@mui/material";
import { H4 } from "../components/Typography";
import { FC } from "react";
import OutboundIcon from "@mui/icons-material/Outbound";
interface CardProps {
  title: string;
  investedAmt: any;
  subAmt: any;
  icon: any;
  returns: any;
}

const CardView: FC<CardProps> = ({
  title,
  investedAmt,
  subAmt,
  icon,
  returns,
}) => {
  return (
    <Box sx={sxStyleBox}>
      <Box
        sx={{
          display: "flex",
          mt: {
            md: 1,
            xs: 0,
          },
        }}
      >
        <Box component="img" src={icon} sx={sxStyleImage} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            marginLeft: 1.5,
            // alignItems:'center'
          }}
        >
          <H4 color="#000000" sx={text}>
            {title}
          </H4>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <H4 color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR} sx={textRow}>
              ₹
              <H4 color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR} sx={text}>
                {investedAmt}
              </H4>
            </H4>
            <H4
              fontWeight={400}
              fontSize={14}
              color="#747474"
              sx={{ ml: 1, fontFamily: "'Poppins', sans-serif" }}
            >
              (Invested)
            </H4>
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          //alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          mt: {
            md: 2,
            xs: 1,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <H4 color="#747474" fontWeight={"500"} sx={text}>
            Current Value
          </H4>
          <H4 color="#000" sx={textRow}>
            ₹
            <H4 color="#000" sx={text}>
              {subAmt}
            </H4>
          </H4>
        </Box>
        <Box
          sx={{
            display: {
              md: "flex",
              xs: "none",
            },
            flexDirection: "row",
            marginLeft: 1,
            alignItems: "flex-end",
          }}
        >
          {returns < 0 ? (
            <OutboundIcon
              style={{
                color: "#f00",
                transform: "rotate(180deg)",
                width: 20,
                height: 20,
                marginRight: 2,
              }}
            />
          ) : (
            <OutboundIcon
              style={{
                color: "#518203",
                marginRight: 2,
                width: 20,
                height: 20,
              }}
            />
          )}
          <H4
            color={returns < 0 ? "#f00" : "#518203"}
            fontWeight={"500"}
            sx={{
              flexDirection: "row",
              display: "flex",
              mt: {
                xs: 2,
              },
            }}
          >
            <H4 color={returns < 0 ? "#f00" : "#518203"} fontWeight={"500"}>
              ₹{" "}
            </H4>
            <H4 color={returns < 0 ? "#f00" : "#518203"} fontWeight={"500"}>
              {" "}
              {returns}
            </H4>
          </H4>
        </Box>
        <Box
          sx={{
            display: {
              md: "none",
              xs: "flex",
            },
            flexDirection: "row",
            marginLeft: 1,
            alignItems: "flex-end",
          }}
        >
          {returns < 0 ? (
            <OutboundIcon
              style={{
                color: "#f00",
                transform: "rotate(180deg)",
                width: 15,
                height: 15,
                marginRight: 2,
              }}
            />
          ) : (
            <OutboundIcon
              style={{
                color: "#518203",
                marginRight: 2,
                width: 15,
                height: 15,
              }}
            />
          )}
          <H4
            color={returns < 0 ? "#f00" : "#518203"}
            fontWeight={"500"}
            sx={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <H4 color={returns < 0 ? "#f00" : "#518203"} fontWeight={"500"}>
              ₹{" "}
            </H4>
            <H4 color={returns < 0 ? "#f00" : "#518203"} fontWeight={"500"}>
              {" "}
              {returns}
            </H4>
          </H4>
        </Box>
      </Box>
    </Box>
  );
};

export default CardView;
const sxStyleImage = {
  height: {
    xs: 30,
    sm: "20%",
    md: 40,
  },
  width: {
    xs: 30,
    sm: "20%",
    md: 40,
  },
  mt: 0.5,
};
const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  fontWeight: "600",
  mt: 0.1,
};
const textRow = {
  display: "flex",
  fontWeight: "620",
  fontSize: 16,
};

const sxStyleBox = {
  marginRight: 4,
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  paddingTop: 2,
  paddingBottom: 2,
  backgroundColor: "#fff",
  flexDirection: "column",
  borderRadius: 3,
  padding: 2,
  mt: {
    xs: 2,
    sm: 1,
    md: 0,
  },
};
